.apc-hero-slider {
  position: relative;
  width: 100%;
  height: 420px;
  border-radius: 14px;
  overflow: hidden;
  isolation: isolate;
  font-family: 'Exo 2', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif;
  --apc-accent: #DE3431;
  --apc-btn-text: #ffffff;
  --apc-panel-bg: #000000;
}

.apc__slide {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: #0a0a0a;
}

.apc__bg {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: visible;
  pointer-events: none;
  background-repeat: no-repeat;
  background-color: transparent;
  filter: brightness(0.9) contrast(1.05);
  isolation: isolate;
}

.apc__overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: none;
}

.apc__inner {
  position: relative;
  z-index: 2;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 40px 50px 40px 50px;
}

.apc__inner--left {
  justify-items: start;
  text-align: left;
  margin-top: 20px;
}

.apc__inner--center {
  justify-items: center;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}

.apc__inner--right {
  justify-items: end;
  text-align: right;
  margin-left: auto;
}

.apc__title {
  font-size: clamp(24px, 3.2vw, 38px);
  line-height: 1.2;
  margin: 0 0 10px;
  color: #ffffff;
  font-weight: 700;
  letter-spacing: -0.01em;
  text-shadow: 2px 2px 6px rgba(0,0,0,0.7);
}

.apc__subtitle {
  font-size: clamp(14px, 1.6vw, 18px);
  margin: 0 0 12px;
  color: rgba(255, 255, 255, 0.95);
  font-weight: 500;
  text-shadow: 1px 1px 4px rgba(0,0,0,0.6);
}

.apc__desc {
  font-size: clamp(12px, 1.3vw, 14px);
  line-height: 1.55;
  margin: 0 0 20px;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 400;
  text-shadow: 1px 1px 3px rgba(0,0,0,0.5);
}

.apc__buttons {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.apc-hero-slider .elementor-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 12px 24px;
  border-radius: 5px;
  text-decoration: none;
  font-weight: 700;
  font-size: 14px;
  border: 2px solid #ffffff;
  color: #ffffff;
  background: transparent;
  transition: 0.3s ease;
  cursor: pointer;
}

.apc-hero-slider .elementor-button:hover {
  background: rgba(255, 255, 255, 0.1);
  transform: translateY(-2px);
}

.apc-hero-slider .elementor-button-text {
  color: #ffffff;
}

.apc__nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.45);
  cursor: pointer;
  z-index: 3;
  border: none;
  transition: all 0.3s ease;
}

.apc__nav:hover {
  background: rgba(0, 0, 0, 0.65);
}

.apc__nav--prev {
  left: 14px;
}

.apc__nav--next {
  right: 14px;
}

.apc__nav::before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E%3Cpath fill='%23ffffff' d='M14.7 5.3 9 11l5.7 5.7-1.4 1.4L6.3 11l7-7z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 22px 22px;
}

.apc__nav--next::before {
  transform: scaleX(-1);
}

/* Swiper Pagination */
.swiper-pagination {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 8px;
  z-index: 10;
}

.swiper-pagination-bullet {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.4);
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  opacity: 1;
}

.swiper-pagination-bullet:hover {
  background: rgba(255, 255, 255, 0.6);
}

.swiper-pagination-bullet-active {
  background: #ffffff;
  width: 24px;
  border-radius: 5px;
}

.apc__mobile-panel {
  display: none;
}

/* Responsive Styles */
@media (max-width: 1366px) {
  .apc-hero-slider {
    border-radius: 0;
  }
}

@media (max-width: 767px) {
  .apc__nav {
    display: none;
  }
  
  .apc-hero-slider[data-arrows-mobile="yes"] .apc__nav {
    display: block;
  }
  
  .apc__slide--overlay .apc__inner {
    display: grid;
  }
  
  .apc__slide--panel {
    position: relative;
    display: flex;
    flex-direction: column;
  }
  
  .apc__slide--panel > .apc__inner {
    display: none !important;
  }
  
  .apc__slide--panel .apc__bg {
    position: relative;
    flex: 0 0 50%;
    height: 50%;
    width: 100%;
    background-position: center center !important;
    background-size: cover !important;
    background-repeat: no-repeat !important;
  }
  
  .apc__slide--panel .apc__overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    padding: 30px 20px;
    background: linear-gradient(to right, rgba(0, 0, 0, 0.8) 50%, transparent);
    z-index: 2;
  }
  
  .apc__slide--panel .apc__overlay .apc__title {
    display: block !important;
    font-size: 22px;
    margin: 0 0 8px;
    color: #ffffff;
    max-width: 280px;
    line-height: 1.2;
  }
  
  .apc__slide--panel .apc__overlay .apc__subtitle {
    display: block !important;
    font-size: 14px;
    margin: 0;
    color: rgba(255, 255, 255, 0.9);
    max-width: 260px;
  }
  
  .apc__slide--panel .apc__mobile-panel {
    display: block !important;
    position: relative;
    flex: 0 0 50%;
    min-height: 50%;
    left: 0;
    right: 0;
    bottom: 0;
    background: var(--apc-panel-bg);
    z-index: 3;
    overflow-y: auto;
    padding: 20px;
  }
  
  .apc__slide--panel .apc__mobile-panel .apc__title,
  .apc__slide--panel .apc__mobile-panel .apc__subtitle {
    display: none !important;
  }
  
  .apc__slide--panel .apc__mobile-panel .apc__inner {
    display: block !important;
    padding: 0;
    max-width: 100%;
    height: auto !important;
  }
  
  .apc__slide--panel .apc__desc {
    font-size: 14px;
    line-height: 1.35;
    max-width: none;
    margin: 0 0 16px;
    color: rgba(255, 255, 255, 0.85);
  }
  
  .apc__slide--panel .apc__buttons {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
  }
  
  .apc__slide--panel .elementor-button {
    padding: 12px 20px;
  }
}